import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, MenuItem } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useEmployee from "../../../hooks/useEmployee";
import useEmailMaster from "../../../hooks/useEmailMaster";
import useBranch from "../../../hooks/useBranch";

import SearchableAutoComplete from "../../../components/SearchableAutoComplete";
import FilterReset from "../../../components/FilterReset";
import { searchPayload, convertedValue, formatDate } from "../../../utils/common";
import { OperatorConstants } from "../../../constants/operator.constants";
import ReactHookFormSelect from "../../../components/ReactHookFormSelect";
import CustomTextField from "../../../components/CustomTextField";
import { useDialog } from "../../../contexts/DialogContext";
import CustomDatePicker from "../../../components/CustomDatePicker";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();
  const initialValues = {
    reportOperator: "eq",
    sessionDateOperator: "btn",
    sessionDate: [new Date(), new Date()],
    sessionDateStr: formatDate(new Date()) + " 00:00:00," + formatDate(new Date()) + " 23:59:59",
    reportType: "daily",
  };

  const { fields, payload, setPayload, setFilterResetFunc, userName } = props;

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => reset);
  }, [reset]);

  const onSubmit = async (data) => {
    try {
      let filters = [];
      if (userName != null && Object.keys(userName).length != 0) {
        filters.push({
          fieldName: "userName",
          fieldValue: userName,
          op: "eq",
          dataType: "string",
          condition: "and",
          isJoin: true,
          entityName: "RadUserEntity",
          attributeName: "radUser",
        });
      }
      if (data.sessionDate != "" && data.sessionDate != null) {
        console.log(data.sessionDateStr, "data.sessionDateStr");
        filters.push({
          fieldName: "createdAt",
          fieldValue: data.sessionDateStr,
          op: data.sessionDateOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.reportType != "" && data.reportType != null) {
        filters.push({
          fieldName: "reportType",
          fieldValue: data.reportType,
          op: data.reportOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      setPayload({
        ...payload,
        filters: filters,
      });
      unSetDialog("advance_filter");
    } catch (err) {
      console.log(err, "errerrerrerr");
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2} pt={8}>
            <Grid item md={2} sm={6}>
              <ReactHookFormSelect
                name="reportOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.string).map((value, k) => (
                  <MenuItem key={k} value={value[0]}>
                    {value[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item md={4} sm={6} xs={8}>
              <ReactHookFormSelect
                name="reportType"
                label="Report Type"
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                <MenuItem key={"daily"} value={"daily"}>
                  Daily
                </MenuItem>
                <MenuItem key={"monthly"} value={"monthly"}>
                  Monthly
                </MenuItem>
              </ReactHookFormSelect>
            </Grid>
          </Grid>
          <Grid container spacing={2} pt={8}>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="sessionDateOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              >
                {Object.entries(OperatorConstants.date).map((t, k) => (
                  <MenuItem key={k} value={t[0]}>
                    {t[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <CustomDatePicker
                name="sessionDate"
                nameTemp="sessionDateStr"
                label="Date "
                range={true}
                control={control}
              />
            </Grid>
          </Grid>
          <FilterReset resetForm={reset} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default AdvanceFilter;
